import comic from './comic';
import taskGroup from './taskGroup';
import comm from './comm';
import auth from './auth';
import staff from './staff';
import role from './role';
import statistic from './statistic';
import worker from './worker';
import statisticNor from './statisticNor';

export default {
  comm,
  auth,
  comic,
  staff,
  role,
  taskGroup,
  statistic,
  worker,
  statisticNor
};
